import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";

export function ExportsEmptyState() {
  return (
    <div className="info-panel mx-4 my-6">
      <strong>No exports yet</strong>
      <p className="mt-2 text-[0.9rem] text-[var(--muted)]">
        Start from{" "}
        <Link to={ROUTES.invoicesPdfs} className="link-quiet">
          Download Invoice PDFs
        </Link>
        ,{" "}
        <Link to={ROUTES.invoicesReceipts} className="link-quiet">
          Download Receipts
        </Link>
        ,{" "}
        <Link to={ROUTES.invoicesCreditNotes} className="link-quiet">
          Download Credit Notes
        </Link>
        , or{" "}
        <Link to={ROUTES.invoicesBulkExport} className="link-quiet">
          Bulk Export PDFs
        </Link>
        .
      </p>
    </div>
  );
}
